import { render, staticRenderFns } from "./article_list.vue?vue&type=template&id=be0a2dac&scoped=true"
import script from "./article_list.vue?vue&type=script&lang=js"
export * from "./article_list.vue?vue&type=script&lang=js"
import style0 from "./article_list.vue?vue&type=style&index=0&id=be0a2dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0a2dac",
  null
  
)

export default component.exports